<script setup lang="ts">
import { ZuordnungImportHeader } from '@/models/ZuordnungImportHeader';
import Select, { type SelectChangeEvent } from 'primevue/select';
import { computed, onMounted, ref, watch, type Ref } from 'vue';

const props = withDefaults(
    defineProps<{
        options?: any[];
        headerModel: ZuordnungImportHeader;
    }>(),
    { options: () => [], header: new ZuordnungImportHeader() },
);

const headerGroupMap = computed(() => {
    const res = {} as Record<string, Record<string, string>[]>;
    props.options.forEach((option) => {
        res[option.type as string] = option.items.map((o: any) => {
            return { id: o.id, variable: o.variable };
        });
    });
    return res;
});
const headerMap = computed(() => {
    const res = [] as Record<string, string>[];
    props.options.forEach((option) => {
        option.items.forEach((o: any) => {
            res.push({ id: o.id, variable: o.variable });
        });
    });
    return res;
});

const emit = defineEmits<{
    (e: 'change', option: SelectChangeEvent): void;
}>();

const modelValue = computed(() => {
    const m =
        headerGroupMap.value[props.headerModel.headergroup || '']?.find((h) => h.variable === props.headerModel.header)
            ?.id ||
        headerMap.value.find((h) => h.variable === props.headerModel.header)?.id ||
        '';
    emit('change', { value: m, originalEvent: new Event('select') });
    return m;
});
</script>

<template>
    <Select
        :model-value="modelValue"
        filter
        :options="options"
        optionValue="id"
        optionLabel="bezeichnung_de"
        optionGroupLabel="type"
        optionGroupChildren="items"
        :placeholder="$t('bitte_waehlen')"
        class="w-full"
        :filterFields="['bezeichnung_de', 'variable']"
        @change="(value) => $emit('change', value)"
    >
        <template #option="slotProps">
            <span class="mx-0_5rem"
                ><b>{{ slotProps.option.variable }}</b></span
            ><span>{{ slotProps.option.bezeichnung_de }}</span>
        </template>
        <template #optiongroup="slotProps">
            <div class="flex align-items-center">
                <i class="fa-regular fa-file"></i>
                <div class="ml-0_5rem">
                    {{ $t('file_type_' + slotProps.option.type.toLowerCase()) }}
                </div>
            </div>
        </template>
    </Select>
</template>
